
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zombie-purge",
      function () {
        return require("private-next-pages/zombie-purge/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zombie-purge"])
      });
    }
  